module.exports = __webpack_public_path__ + "img/89.bda200ab.png";